export const clientContactPermissions = [
  { value: "contracts", label: "Contrats" },
  { value: "invoices", label: "Factures et relances" },
  { value: "quotations", label: "Devis" },
];

// Les contacts existants sans habilitations restent disponibles.
export const canManageClientDocument = (contact, permission) =>
  contact.active !== false && (contact.accessRights || contact.role
    ? getEffectiveClientContactAccess(contact, permission === "quotations" ? "commercialTerms" : permission) !== "—"
    : (!Array.isArray(contact.habilitations) || contact.habilitations.includes(permission)));

export const retireClientContact = (contacts, index, retiredAt = new Date().toISOString()) =>
  contacts.map((contact, currentIndex) => currentIndex === index
    ? { ...contact, active: false, retiredAt }
    : contact);

export const clientContactRoles = [
  { value: 'admin', label: 'Admin' },
  { value: 'direction', label: 'Direction' },
  { value: 'rh', label: 'RH' },
  { value: 'compta', label: 'Compta' },
  { value: 'site', label: 'Responsable de site' },
  { value: 'manager', label: 'Manager' },
];
export const clientContactAccessMatrix = [
  ['contracts', 'Contrats de mise à disposition', ['G', 'G', 'G', '—', 'G', 'G']],
  ['signature', 'Signature des contrats', ['G', 'G', '—', '—', 'G', '—']],
  ['invoices', 'Factures et avoirs', ['G', 'G', '—', 'G', '—', '—']],
  ['timesheets', 'Relevés d’heures', ['G', 'G', 'G', '—', 'G', 'G']],
  ['hoursValidation', 'Validation des heures', ['G', 'G', 'G', '—', 'G', 'G']],
  ['staffRequests', 'Demandes de personnel', ['G', 'G', 'G', '—', 'G', 'G']],
  ['orders', 'Commandes', ['G', 'G', 'G', '—', 'G', 'G']],
  ['planning', 'Planning des intérimaires', ['G', 'G', 'G', '—', 'G', 'G']],
  ['workerDocuments', 'Documents des intérimaires', ['G', 'G', 'G', '—', 'G', '—']],
  ['commercialTerms', 'Tarifs et accords commerciaux', ['G', 'G', '—', 'G', '—', '—']],
  ['reporting', 'Reporting et statistiques', ['G', 'G', 'G', '—', 'G', '—']],
  ['users', 'Gestion des utilisateurs', ['G', '—', '—', '—', '—', '—']],
];
export const getClientContactAccess = (role, feature) => {
  const index = clientContactRoles.findIndex((item) => item.value === role);
  return clientContactAccessMatrix.find(([key]) => key === feature)?.[2]?.[index] || '—';
};

export const getEffectiveClientContactAccess = (contact, feature) => {
  const custom = contact.accessRights?.[feature];
  if (["G", "V", "L"].includes(custom)) return "G";
  if (custom === "—") return "—";
  if (contact.role) return getClientContactAccess(contact.role, feature);
  const legacy = { contracts: "contracts", invoices: "invoices", commercialTerms: "quotations" }[feature];
  if (legacy && (!Array.isArray(contact.habilitations) || contact.habilitations.includes(legacy))) return "G";
  return "—";
};
